import { useState } from "react";
import { 
  INoCessionSIPSErrors,
  INoCessionSIPSErrorsResponse,
  NoSIPSCessionSelection, 
  NoSIPSCessionStates
} from "../types/noSIPSCession";
import { 
  default as noSIPSCessionService
} from "../services/noSIPSCession";
import axios from "axios";
import contractActions from "@/components/Contracts/actions/newActions"
import { useDispatch } from "react-redux";
import { ContractDisplayTypes } from "../types/contracts";

interface IUseNoSIPSCessionProps {
  contractName: string;
  type: ContractDisplayTypes;
}

const useNoSIPSCession = ({
  contractName,
  type,
}: IUseNoSIPSCessionProps) => {
  const dispatch = useDispatch();

  const [errors, setErrors] = useState<INoCessionSIPSErrors | undefined>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmitNoSIPSCession = async (
    newNoSIPSCessionSelection: NoSIPSCessionSelection
  ) => {
    dispatch(contractActions[type].setNoSIPSCessionState("requested"));
    setIsSubmitting(true);

    noSIPSCessionService.sendSIPSCessionChange({
      contractName,
      newNoSIPSCessionSelection
    })
    .then(res => {
      dispatch(contractActions[type].setNoSIPSCessionIsWaitingForSignature(res.promise.data.waiting_for_signature));
      // if(!res.promise.data.waiting_for_signature) {
      //   handleClose();
      // }
    })
    .catch(err => {
      dispatch(contractActions[type].setNoSIPSCessionState('unactive'));
      if (axios.isAxiosError<INoCessionSIPSErrorsResponse>(err))  {
        if (err.response?.status === 400) {
          setErrors(err.response?.data.errors);
        }
      }
    })
    .finally(() => {
      setIsSubmitting(false);
    })
  };

  return {
    errors,
    isSubmitting,
    handleSubmitNoSIPSCession
  }

}

export default useNoSIPSCession;